import React from 'react';
import { useResponsive } from '@sg/garnish';

import { useCustomer } from '@order/Customer';
import { useLocalizationContext } from '@order/Localization';

import { CreditCardFormContent, useCreditCardHandlers } from '../CreditCard';
import { Modal } from '../Modal';

export const CreditCardEditModal = (props: CreditCardEditModalProps) => {
  const { visible, paymentMethodId, onRequestClose } = props;

  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  const { customer } = useCustomer();
  const { billingAccounts } = customer;

  const billingAccount = billingAccounts?.find(
    (item) => item.id === paymentMethodId,
  );

  const {
    submitBillingAccountResponse: { fetching: isSubmitting },
    updateBillingAccountResponse: { fetching: isUpdating },
    deleteBillingAccountResponse: { fetching: isDeleting },
    handleOnEdit,
    handleOnSave,
    handleOnDelete,
  } = useCreditCardHandlers({
    paymentMethodId,
    onComplete: onRequestClose,
  });

  return (
    <Modal
      fitHeight
      visible={visible}
      accessibilityLabel={t('credit-card-form.edit')}
      presentationStyle="pageSheet"
      size={match(['full', 'small'])}
      onRequestClose={onRequestClose}
    >
      <Modal.Header onClose={onRequestClose}>
        {t('credit-card-form.edit')}
      </Modal.Header>

      <CreditCardFormContent
        isVisible
        vault="order"
        mode="edit"
        account={billingAccount}
        isSaving={isSubmitting || isUpdating}
        isDeleting={isDeleting}
        onEdit={handleOnEdit}
        onSave={handleOnSave}
        onDelete={handleOnDelete}
      />
    </Modal>
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type CreditCardEditModalProps = {
  readonly paymentMethodId?: string;
  readonly visible: boolean;
  readonly onRequestClose: () => void;
};
